import React from "react"
import { AccessTime } from "@mui/icons-material"
import styles from './styles'

const SectionedTitle = ({ text, status }) => {
  const classes = styles()
  return (
  <div className={classes.sectionTitle}>
    {status === 'PROCESSING' && (
      <AccessTime style={{ color: '#FFF' }} />
    )}
    {text}
  </div>
  )
}

export default SectionedTitle
